import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { clubAPI } from '../services/api';
import './ClubFund.css';

function ClubBroadcast() {
  const { clubId } = useParams();
  const [activeTab, setActiveTab] = useState('email');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  const handleSendEmail = async (e) => {
    e.preventDefault();
    setSending(true);
    setResult(null);
    try {
      const data = await clubAPI.broadcastEmail(clubId, subject.trim(), message.trim());
      setResult({ success: true, message: `Broadcast email sent to ${data.sent || 0} member(s)` });
      setSubject('');
      setMessage('');
    } catch (err) {
      setResult({ success: false, message: err.response?.data?.error || 'Failed to send broadcast email' });
    }
    setSending(false);
  };

  const handleSendSms = async (e) => {
    e.preventDefault();
    setSending(true);
    setResult(null);
    try {
      const data = await clubAPI.broadcastSms(clubId, message.trim());
      setResult({ success: true, message: `Broadcast SMS sent to ${data.sent || 0} member(s)` });
      setMessage('');
    } catch (err) {
      setResult({ success: false, message: err.response?.data?.error || 'Failed to send broadcast SMS' });
    }
    setSending(false);
  };

  const handleSendPush = async (e) => {
    e.preventDefault();
    setSending(true);
    setResult(null);
    try {
      const data = await clubAPI.broadcastPush(clubId, message.trim());
      setResult({ success: true, message: `Push notification sent to ${data.sent || 0} member(s)` });
      setMessage('');
    } catch (err) {
      setResult({ success: false, message: err.response?.data?.error || 'Failed to send push notification' });
    }
    setSending(false);
  };

  const tabs = ['email', 'sms', 'push'];

  const inputStyle = {
    width: '100%',
    background: 'rgba(0,0,0,0.25)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '8px',
    color: '#fff',
    padding: '0.75rem',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
  };

  const textareaStyle = {
    ...inputStyle,
    resize: 'vertical',
  };

  return (
    <div>
      <h2>Broadcast Message</h2>
      <p style={{ color: '#999', fontSize: '0.85rem', marginBottom: '1rem' }}>
        Send a message to all club members via email, SMS, or push notification.
      </p>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {tabs.map(tab => (
          <button
            key={tab}
            onClick={() => { setActiveTab(tab); setResult(null); setMessage(''); setSubject(''); }}
            className={`history-tab ${activeTab === tab ? 'active' : ''}`}
            style={{
              padding: '8px 20px',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              background: activeTab === tab ? '#fbbf24' : 'rgba(0,0,0,0.25)',
              color: activeTab === tab ? '#000' : '#aaa',
              fontWeight: 600,
              textTransform: 'uppercase',
              fontSize: 12,
            }}
          >
            {tab === 'email' ? 'Email' : tab === 'sms' ? 'SMS' : 'Push'}
          </button>
        ))}
      </div>

      {activeTab === 'email' && (
        <form onSubmit={handleSendEmail} className="fund-form">
          <div className="form-group">
            <label>Subject</label>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Email subject line"
              required
              className="dark-input"
              style={inputStyle}
            />
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Write your message to all club members..."
              rows={6}
              required
              className="dark-input"
              style={textareaStyle}
            />
          </div>
          {result && (
            <div className={`result-message ${result.success ? 'success' : 'error'}`}>
              {result.message}
            </div>
          )}
          <button type="submit" className="btn-submit" disabled={sending || !subject.trim() || !message.trim()}>
            {sending ? 'Sending...' : 'Send Broadcast Email'}
          </button>
        </form>
      )}

      {activeTab === 'sms' && (
        <form onSubmit={handleSendSms} className="fund-form">
          <div className="form-group">
            <label>Message</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Write your SMS message..."
              rows={4}
              required
              className="dark-input"
              style={textareaStyle}
            />
          </div>
          {result && (
            <div className={`result-message ${result.success ? 'success' : 'error'}`}>
              {result.message}
            </div>
          )}
          <button type="submit" className="btn-submit" disabled={sending || !message.trim()}>
            {sending ? 'Sending...' : 'Send Broadcast SMS'}
          </button>
        </form>
      )}

      {activeTab === 'push' && (
        <form onSubmit={handleSendPush} className="fund-form">
          <div className="form-group">
            <label>Message</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Write your push notification message..."
              rows={4}
              required
              className="dark-input"
              style={textareaStyle}
            />
          </div>
          {result && (
            <div className={`result-message ${result.success ? 'success' : 'error'}`}>
              {result.message}
            </div>
          )}
          <button type="submit" className="btn-submit" disabled={sending || !message.trim()}>
            {sending ? 'Sending...' : 'Send Push Notification'}
          </button>
        </form>
      )}
    </div>
  );
}

export default ClubBroadcast;
